<template>
  <div>
    <page-title :title="title"></page-title>
    <div style="height: 1000px">
      <object :data="pdfLink" height="100%" width="100%" type="application/pdf">
        <p>This browser does not support PDFs. Please download the PDF to view it: 
<a :href="pdfLink">Download PDF</a>.</p>
      </object>
    </div>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'
  export default {
    name: 'resume',
    data () {
      return {
        title: 'Resume',
        pdfLink: 'https://jonnypickett.s3-us-west-1.amazonaws.com/current_resume.pdf'
      }
    },
    components: {
      PageTitle
    }
  }
</script>

<styles>

</styles>



// WEBPACK FOOTER //
// Resume.vue?1982a04e